import styled from 'styled-components';

import {
  whiteSphera,
  greenSp,
  brandBlack,
  grayMediumSphera,
  brandYellowgreen
} from 'src/utilities/UIStyles/variables/Colors';

import { fadeIn, fadeOut } from 'src/utilities/animations';

export const ModalCampaignSuccess = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalCampaignSuccess ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.6);
  animation: ${(props) => (props.showModalCampaignSuccess ? fadeIn : fadeOut)} 0.5s linear;

  > div {
    display: flex;
    flex-direction: column;
    width: 60%;
    border-radius: 5px;
    background-color: ${whiteSphera};
    padding: 3%;

    > h3 {
      font-size: 1.5vw;
      color: ${grayMediumSphera};
    }
    > h2 {
      font-size: 2.5vw;
      text-align: center;
      color: ${brandBlack};
      > span {
        color: ${greenSp};
        font-size: 2.5vw;
      }
    }
    > p {
      color: ${brandBlack};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > h2 {
        > span {
        }
      }

      > a {
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      width: 95%;

      > h2 {
        font-size: 7vw;
        text-align: center;

        > span {
        }
      }

      > a {
        font-size: 4.3vw;
        width: 100%;
        padding: 3% 8%;

        &:hover {
        }
      }
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  max-width: 800px;
  border-radius: 5px;
  background-color: ${whiteSphera};
  padding: 3%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const InfoContainer = styled.section`
  margin: 20px 0;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  p {
    width: 45%;
    color: ${brandBlack};
    font-size: 1.1vw;
    margin-bottom: 5px;
  }
`;

export const ConfirmButton = styled.button`
  color: ${brandBlack};
  font-size: 1.2vw;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  width: 40%;
  margin: 0;
  padding: 1%;
  border: none;
  border-radius: 5px;
  background-color: ${brandYellowgreen};
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    transform: scale(1.1);
  }
`;

export const CloseButton = styled.button`
  color: ${whiteSphera};
  font-size: 1.2vw;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  width: 40%;
  margin: 0;
  padding: 1%;
  border: none;
  border-radius: 5px;
  background-color: ${brandBlack};
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    transform: scale(1.1);
  }
`;

export const MainInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: 0;
  h3 {
    width: 30%;
    font-size: 1.4vw;
    color: ${grayMediumSphera};
    margin-bottom: 5px;
    text-align: center;
    font-weight: 100;
  }
  > p {
    color: ${greenSp};
    text-align: center;
    font-size: 1.4vw;
    font-weight: bold;
  }
`;

export const ComplementaryInfo = styled.div`
  display: flex;
  justify-content: center;
  width: 70%;
  margin: 2% 0;
  padding: 2%;
  border: 1px solid ${brandBlack};
  border-radius: 10px;

  table {
    width: 100%;
    border-collapse: collapse;

    thead {
      background-color: ${brandBlack};
      color: ${whiteSphera};
    }

    th,
    td {
      padding: 8px;
      font-size: 1vw;
      text-align: left;
      border-bottom: 1px solid ${brandBlack};
    }

    td {
      color: ${brandBlack};
    }
  }
`;
